<div class="formfield nes-flex nes-flex-col nes-w-full">
    <label class="nes-w-full nes-text-form-label nes-font-bold nes-font-sans nes-text-left nes-mb-2">
        {{ 'COMPANY_DATA.INPUT.USER_HISTORY.LABEL_SELECT' | translate }}
    </label>
    <div class="formfield__inputContainer nes-w-full nes-ml-0 nes-pl-0">
        <select
            class="select textInput--fullWidth"
            (ngModelChange)="selected.emit($event)"
            [(ngModel)]="selectedUserId"
            privacySensitive>
            <option
                *ngFor="let user of users"
                [value]="user.id"
                privacySensitive>
                {{ user | displayName | async }}
            </option>
        </select>
    </div>
</div>
